// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
}

.icon {
  display: inline-block;
}
.icon mat-icon {
  border-radius: 50%;
  display: inline;
  padding: 5px;
}
.icon.layers mat-icon {
  background-color: rgb(255, 228.4633027523, 190);
  color: #FFA625;
}
.icon.speed mat-icon {
  background-color: rgb(252.1358695652, 226.8641304348, 227.0326086957);
  color: #EE5859;
}
.icon.thermostat mat-icon {
  background-color: rgb(222, 238.5, 255);
  color: #45a2ff;
}
.icon.energy_savings_leaf mat-icon {
  background-color: rgb(116.1647727273, 212.8352272727, 131.5909090909);
  color: #298738;
}
.icon.cloud_queue mat-icon {
  background-color: rgb(163, 238.5714285714, 255);
  color: #005c70;
}
.icon.gas_meter mat-icon {
  background-color: rgb(255, 230.9267015707, 217);
  color: #ff8640;
}
.icon.water mat-icon {
  background-color: #99e7ff;
  color: #00c3ff;
}
.icon.electric_meter mat-icon {
  background-color: rgb(255, 230.9267015707, 217);
  color: #ff8640;
}
.icon.local_florist mat-icon {
  background-color: rgb(116.1647727273, 212.8352272727, 131.5909090909);
  color: #298738;
}
.icon.local_florist2 mat-icon {
  background-color: rgb(253.8, 250.6, 154.2);
  color: #ada800;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sensor-icon/sensor-icon.component.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;AADF;;AAIA;EACE,qBAAA;AADF;AAGE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;AADJ;AAKI;EACE,+CAAA;EACA,cAAA;AAHN;AAQI;EACE,qEAAA;EACA,cAAA;AANN;AAWI;EACE,sCAAA;EACA,cAAA;AATN;AAcI;EACE,qEAAA;EACA,cAAA;AAZN;AAiBI;EACE,+CAAA;EACA,cAAA;AAfN;AAoBI;EACE,+CAAA;EACA,cAAA;AAlBN;AAuBI;EACE,yBAAA;EACA,cAAA;AArBN;AA0BI;EACE,+CAAA;EACA,cAAA;AAxBN;AA6BI;EACE,qEAAA;EACA,cAAA;AA3BN;AAgCI;EACE,0CAAA;EACA,cAAA;AA9BN","sourcesContent":["@use 'sass:color';\n\n:host {\n  display: inline-block;\n}\n\n.icon {\n  display: inline-block;\n\n  mat-icon {\n    border-radius: 50%;\n    display: inline;\n    padding: 5px;\n  }\n\n  &.layers {\n    mat-icon {\n      background-color: color.adjust(#FFA625, $lightness: 30%);\n      color: #FFA625;\n    }\n  }\n\n  &.speed {\n    mat-icon {\n      background-color: color.adjust(#EE5859, $lightness: 30%);\n      color: #EE5859;\n    }\n  }\n\n  &.thermostat {\n    mat-icon {\n      background-color: color.adjust(#45a2ff, $lightness: 30%);\n      color: #45a2ff;\n    }\n  }\n\n  &.energy_savings_leaf {\n    mat-icon {\n      background-color: color.adjust(#298738, $lightness: 30%);\n      color: #298738;\n    }\n  }\n\n  &.cloud_queue {\n    mat-icon {\n      background-color: color.adjust(#005c70, $lightness: 60%);\n      color: #005c70;\n    }\n  }\n\n  &.gas_meter {\n    mat-icon {\n      background-color: color.adjust(#ff8640, $lightness: 30%);\n      color: #ff8640;\n    }\n  }\n\n  &.water {\n    mat-icon {\n      background-color: color.adjust(#00c3ff, $lightness: 30%);\n      color: #00c3ff;\n    }\n  }\n\n  &.electric_meter {\n    mat-icon {\n      background-color: color.adjust(#ff8640, $lightness: 30%);\n      color: #ff8640;\n    }\n  }\n\n  &.local_florist {\n    mat-icon {\n      background-color: color.adjust(#298738, $lightness: 30%);\n      color: #298738;\n    }\n  }\n\n  &.local_florist2 {\n    mat-icon {\n      background-color: color.adjust(rgb(252, 244, 3), $lightness: 30%);\n      color: #ada800;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
